import { Check } from "lucide-react";

const PHASES = [
  { key: "pull", label: "Pull" },
  { key: "print", label: "Print" },
  { key: "pack", label: "Pack" },
];

export const PhaseStepper = ({ phase, done, onSelect }) => (
  <div className="flex items-center gap-1" data-testid="phase-stepper">
    {PHASES.map((p, idx) => {
      const active = phase === p.key;
      const isDone = done[p.key];
      return (
        <div key={p.key} className="flex items-center flex-1 last:flex-none">
          <button
            onClick={() => onSelect(p.key)}
            className={`flex items-center gap-2 px-3 py-2 rounded-full transition-colors ${
              active ? "bg-[#00D4FF]/15 border border-[#00D4FF]/40" : "border border-transparent hover:bg-white/[0.04]"
            }`}
            data-testid={`phase-tab-${p.key}`}
          >
            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
              isDone ? "bg-[#10B981] text-white" : active ? "bg-[#00D4FF] text-[#0a0a14]" : "bg-white/10 text-white/50"
            }`}>
              {isDone ? <Check className="w-3.5 h-3.5" /> : idx + 1}
            </span>
            <span className={`text-sm font-semibold ${active ? "text-white" : isDone ? "text-[#10B981]/80" : "text-white/40"}`}>
              {p.label}
            </span>
          </button>
          {idx < PHASES.length - 1 && <div className={`flex-1 h-px mx-1 ${isDone ? "bg-[#10B981]/50" : "bg-white/10"}`} />}
        </div>
      );
    })}
  </div>
);
